import type { Ref } from 'vue';
import { computed } from 'vue';

import type { ITranslationsKeyMap } from '@modules/i18n/types';

export function getTranslationKeys(): Ref<ITranslationsKeyMap> {
  return computed(() => ({
    admin: {
      partners: {
        list_partners: {
          tracker_settings: {
            tabs: {
              subaffiliate_condition: {
                tab_name: 'TAB_NAME',
                form: {
                  subaffiliate_condition_id: 'FORM_SUBAFFILIATE_CONDITION_ID',
                  date: 'FORM_DATE',
                },
              },
            },
          },
        },
      },
    },
  }));
}
